import { isCheckoutStage } from '../workflow/stagesControl'
import { ON_CHECKOUT_STAGE } from '../status/statusControl'

export function checkoutStatus(stage) {
  return {
    match: isCheckoutStage(stage),
    status: ON_CHECKOUT_STAGE
  }
}
